export default "__VITE_ASSET__CL7u88YL__"